import { api, ApiError } from "@/api/api";
import { EpisodeDetails } from "@/api/episodes-types";
import { useQuery } from "@tanstack/react-query";

export function useEpisodeById(id: string | undefined) {
  return useQuery<EpisodeDetails, ApiError>({
    queryKey: ["GET", "episodeDetails", id],
    queryFn: () => api.episodes.episodeId.get({ episodeId: id! }),
    enabled: !!id,
  });
}
